import { BetType } from 'core/widgets/Bet/types';
import { getBetSum } from 'core/widgets/Bet/utils';
import { put } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';
import { saveRoundBetAction, saveRoundBetSuccessAction } from '../actions';

export function* saveRoundBetSaga({
  payload: confirmedBets,
}: ActionType<typeof saveRoundBetAction>) {
  const betSum = confirmedBets ? getBetSum(confirmedBets) : 0;
  const roundBet: BetType | null = betSum > 0 ? confirmedBets : null;

  yield put(saveRoundBetSuccessAction(roundBet));
}
